import React, { useState, useEffect } from 'react';
import {
  Tab, Tabs, TabList, TabPanel
} from 'react-tabs';
import '../../index.css';
import Logo1 from '../../assets/images/course1.png';
import Logo3 from '../../assets/images/course3.png';

import BitSchool from './SchoolsGallery';

function Gallery() {
  const [selectedTab, setSelectedTab] = useState('BIT School');

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Purple Academy - Gallery';
  }, []);

  const handleTabClick = (tabName) => {
    setSelectedTab(tabName);
  };

  return (
    <div className="pt-20">
      <section className="relative mb-52">
        <div className="content">
          <img src={Logo1} alt="" className="hidden lg:block w-32 h-auto right-8 absolute" />
          <div className="">
            <h1 className="section-header">Gallery</h1>
            <p className="font-semibold">Here are some more photos and videos from our trainings.</p>
            <p className="my-3">Welcome to our gallery section, we hope you would have a swell time.</p>
          </div>
          <div className="">
            <img src={Logo3} alt="" className="hidden lg:block w-32 h-auto absolute left-8 mt-72 object-contain" />
          </div>
          <Tabs className="md:mt-20">
            <TabList selectedTabClassName="react-tabs__tab--selected">
              <div className="flex flex-wrap md:gap-8 w-full border-b-2 border-[#d9d9d9]">
                <Tab onClick={() => handleTabClick('BIT School')}>BIT School</Tab>
                <Tab onClick={() => handleTabClick('Culture School')}>Culture School</Tab>
                <Tab onClick={() => handleTabClick('Banking School')}>Banking School</Tab>
                <Tab onClick={() => handleTabClick('Business School')}>Business School</Tab>
                <Tab onClick={() => handleTabClick('Leadership School')}>Leadership School</Tab>
                <Tab onClick={() => handleTabClick('SME School')}>SME School</Tab>
              </div>
            </TabList>

            {[1, 2, 3, 4, 5, 6].map(() => (
              <TabPanel selectedTabPanelClassName="active-tabs">
                <BitSchool selectedtab={selectedTab} />
              </TabPanel>
            ))}
          </Tabs>
        </div>
      </section>
    </div>
  );
}

export default Gallery;
